export enum LobAssignmentPermissions {
  LobAssignment = 'lob-assignment',
  AssignmentAll = 'assignment-all',
  AssignmentReceived = 'assignment-received',
  AssignmentShared = 'assignment-shared',
  AssignmentOverview = 'assignment-overview',
  AssignmentArchived = 'assignment-archived',
}
